var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdopt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 182,
    viewBox: "0 0 160 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.974 150.54L133.673 129.238C130.365 125.93 125.867 124.078 121.192 124.078H115.282L106.462 128.488H88.8205C83.9692 128.488 80 132.458 80 137.309V146.129",
    stroke: "#3F4D61",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.513 177.004L119.693 168.183H66.7695L27.0771 128.491L34.0012 126.771C40.7489 125.095 47.9377 126.639 53.3623 131.005L71.1797 146.132H106.462",
    stroke: "#3F4D61",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02539 31.4609L26.3269 52.7625C29.6346 56.0702 34.1331 57.9225 38.808 57.9225H44.7177L53.5382 53.5122H71.1792C76.0305 53.5122 79.9997 49.543 79.9997 44.6917V35.8712",
    stroke: "#3F4D61",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4873 5L40.3078 13.8205H93.2309L132.923 53.5128L125.999 55.2328C119.251 56.9087 112.063 55.3651 106.638 50.9989L88.8206 35.8718H53.5386",
    stroke: "#3F4D61",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9996 74.3338C82.6017 69.3502 88.1145 66.0866 94.2448 66.8805C101.301 67.7625 106.461 74.1133 106.461 81.2138C106.461 88.8877 103.418 96.2528 97.9935 101.677L79.9996 119.671L62.0058 101.677C56.5812 96.2528 53.5381 88.8877 53.5381 81.2138C53.5381 73.7164 59.2714 67.1892 66.7689 66.7923C72.5022 66.4836 77.574 69.6148 79.9996 74.3779V74.3338Z",
    stroke: "#3F4D61",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdopt);
export default __webpack_public_path__ + "static/media/adopt.b062045605017ca58c488f520a3af48a.svg";
export { ForwardRef as ReactComponent };